import React from 'react';
import Card from '../../../../ui/canon/Card.jsx';
import { ChartBarIcon } from '@heroicons/react/24/outline';

export default function SprintStatsCards({ sprintCounts, className = '' }) {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-4 gap-4 ${className}`}>
      {/* Total Sprints */}
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-succession-text-secondary">Total Sprints</p>
            <p className="text-2xl font-bold text-succession-text-primary mt-1">
              {sprintCounts.total || 0}
            </p>
          </div>
          <div className="w-10 h-10 bg-succession-primary-10 rounded-lg flex items-center justify-center">
            <ChartBarIcon className="w-5 h-5 text-succession-primary" />
          </div>
        </div>
      </Card>

      {/* Active */}
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-succession-text-secondary">Active</p>
            <p className="text-2xl font-bold text-succession-success mt-1">
              {sprintCounts.active || 0}
            </p>
          </div>
          <div className="w-10 h-10 bg-succession-success-bg rounded-lg flex items-center justify-center">
            <div className="w-3 h-3 bg-succession-success rounded-full animate-pulse"></div>
          </div>
        </div>
      </Card>

      {/* Planned */}
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-succession-text-secondary">Planned</p>
            <p className="text-2xl font-bold text-succession-primary mt-1">
              {sprintCounts.planned || 0}
            </p>
          </div>
          <div className="w-10 h-10 bg-succession-primary-10 rounded-lg flex items-center justify-center">
            <div className="w-3 h-3 bg-succession-primary rounded-full"></div>
          </div>
        </div>
      </Card>

      {/* Completed */}
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-succession-text-secondary">Completed</p>
            <p className="text-2xl font-bold text-succession-text-secondary mt-1">
              {sprintCounts.closed || 0}
            </p>
          </div>
          <div className="w-10 h-10 bg-succession-bg-secondary rounded-lg flex items-center justify-center">
            <div className="w-3 h-3 bg-succession-text-secondary rounded-full"></div>
          </div>
        </div>
      </Card>
    </div>
  );
}

